import { Input } from '@/ui';

interface TextFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  description?: string;
}

const TextField = ({
  id,
  label,
  value,
  onChange,
  error,
  disabled,
  placeholder,
  description
}: TextFieldProps) => (
  <div className="flex flex-col gap-1">
    <Input
      id={id}
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      placeholder={placeholder}
      helpText={description}
    />
    {error && <p className="text-sm text-red-500 dark:text-red-400">{error}</p>}
  </div>
);

export default TextField;
